module.exports = __webpack_public_path__ + "img/people-at-table.7a42d44f.svg";